export const probationaryVacationAndResignationAgreement = (name?: string, date?: string) => {
  return [
    { text: 'Driver Probationary, Vacation and Resignation Agreement', style: 'h1' },

    { text: "This agreement outlines the terms and conditions of driver-contractors during their first month of probationary work with Sierra Expediting inc. It also specifies the requirements for requesting leave or resignation.", style: 'p' },

    { text: "Probationary Period", style: 'p', bold: true },

    { text: "1. Duration", style: 'p', bold: true, margin: [20, 0, 0, 10] },
    { text: "- The probationary period for new drivers is one month from the start date of employment.", style: 'p', margin: [40, 0, 0, 10] },

    { text: "2. Termination", style: 'p', bold: true, margin: [20, 0, 0, 10] },
    { text: "- During the probationary period, Sierra Expediting inc reserves the right to terminate the employment contract if the driver does not meet the company's standards or violates any company policies. The decision to terminate will be at the discretion of the Safety Department.", style: 'p', margin: [40, 0, 0, 10] },

    { text: "3. Penalties", style: 'p', bold: true, margin: [20, 0, 0, 10] },
    { text: "- The Safety Department may impose fines for violations of company policies during the probationary period..", style: 'p', margin: [40, 0, 0, 10] },

    { text: "Vacation and Resignation", style: 'p', bold: true },

    { text: "1. Notice Requirement", style: 'p', bold: true, margin: [20, 0, 0, 10] },
    { text: "- If a driver wishes to take vacation or resign from their position, they must provide at least 10 days' notice to Sierra Expediting inc.", style: 'p', margin: [40, 0, 0, 10] },

    { text: "2. Penalty for Insufficient Notice", style: 'p', bold: true, margin: [20, 0, 0, 10] },
    { text: "- Failure to provide 10 days' notice will result in a penalty of $300, which will be deducted from the driver's final paycheck.", style: 'p', margin: [40, 0, 0, 10] },

    { text: "Acknowledgment", style: 'p', bold: true },

    { text: "By signing this agreement, I acknowledge that I have read and understand the terms and conditions of my probationary employment with Sierra Expediting inc. I agree to comply with all requirements outlined in this agreement and understand the consequences of non-compliance.", style: 'p' },

    { canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 150,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 170,
          y1: 0,
          x2: 320,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 340,
          y1: 0,
          x2: 490,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
    },

    { text: `${name}`, margin: [0,-22, 0, 0]},
    { text: "Driver's Name", style: 'label', margin: [0,5,0,0]},
    { text: "Driver's Signature", style: 'label', margin: [170,-12,0,0]},
    { text: `${date}`, margin: [340,-32, 0, 0]},
    { text: "Date", style: 'label', margin: [340,5,0,0] },

    { text: '', pageBreak: 'before' },
  ];
};